<template>
    <svg
        fill="none"
        height="19"
        viewBox="0 0 17 19"
        width="17"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M3.1875 11.75C2.01875 11.75 1.0625 10.7375 1.0625 9.5C1.0625 8.2625 2.01875 7.25 3.1875 7.25C4.35625 7.25 5.3125 8.2625 5.3125 9.5C5.3125 10.7375 4.35625 11.75 3.1875 11.75ZM3.1875 8.375C2.60312 8.375 2.125 8.88125 2.125 9.5C2.125 10.1188 2.60312 10.625 3.1875 10.625C3.77187 10.625 4.25 10.1188 4.25 9.5C4.25 8.88125 3.77187 8.375 3.1875 8.375Z"
            fill="currentColor" />
        <path
            d="M8.5 11.75C7.33125 11.75 6.375 10.7375 6.375 9.5C6.375 8.2625 7.33125 7.25 8.5 7.25C9.66875 7.25 10.625 8.2625 10.625 9.5C10.625 10.7375 9.66875 11.75 8.5 11.75ZM8.5 8.375C7.91562 8.375 7.4375 8.88125 7.4375 9.5C7.4375 10.1188 7.91562 10.625 8.5 10.625C9.08437 10.625 9.5625 10.1188 9.5625 9.5C9.5625 8.88125 9.08437 8.375 8.5 8.375Z"
            fill="currentColor" />
        <path
            d="M13.8125 11.75C12.6437 11.75 11.6875 10.7375 11.6875 9.5C11.6875 8.2625 12.6437 7.25 13.8125 7.25C14.9813 7.25 15.9375 8.2625 15.9375 9.5C15.9375 10.7375 14.9813 11.75 13.8125 11.75ZM13.8125 8.375C13.2281 8.375 12.75 8.88125 12.75 9.5C12.75 10.1188 13.2281 10.625 13.8125 10.625C14.3969 10.625 14.875 10.1188 14.875 9.5C14.875 8.88125 14.3969 8.375 13.8125 8.375Z"
            fill="currentColor" />
    </svg>
</template>

<script setup lang="ts">
    const props = defineProps<{
        background?: string;
    }>();

    const background = computed(() => props.background || '#FFFFFF');
</script>

<style scoped></style>
